/**
 * Role-Based Access Control (RBAC) permission checker.
 *
 * Roles:
 * - super_admin: full access to everything
 * - admin: can view, create, edit; cannot delete
 * - operator / staff: can only view
 */
export function hasPermission(user, permission) {
  if (!user) return false;
  const role = user.role;

  if (role === 'super_admin') {
    return true;
  }
  
  if (role === 'admin') {
    // admin cannot delete facilities, only super_admin can
    if (permission === 'facility.delete') return false;
    return true;
  }
  
  if (role === 'operator' || role === 'staff') {
    return permission === 'facility.view' || permission === 'route.view' || permission === 'journey.view';
  }
  
  return false;
}
